function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Operations'))  {
    return [
    {
      title: 'Operations',
      icon: 'mdi-office-building',
      items: [
        {
          icon: 'mdi-file-code',
          title: 'Engineering',
          path: '/OpsEngineering'
        },
        {
          icon: 'mdi-arrow-up-circle',
          title: 'Enhancements',
          path: '/OpsEnhancements'
        },
        {
          icon: 'mdi-web',
          title: 'Marketing',
          path: '/OpsMarketing'
        },
        {
          icon: 'mdi-currency-usd',
          title: 'Sales',
          path: '/OpsSales'
        }
      ]
    }
  ] } else return []
}

export default buildMenu